<!-- Aktionen mit jf-table-row-actions für konsistentes jf-lib Styling -->
<jf-table-row-actions
  [primaryButton]="viewButton"
  [secondaryButton]="editButton"
  [tertiaryButton]="deleteButton"
/>
